const sinDataCard = () => {
    return (
        <div>
            <label> Sin data</label>
        </div>
    );
}

export default sinDataCard;